/* eslint-disable */
// src/layouts/localDesechos/data/localDesechosTableData.js

export default function localDesechosTableData({ machines }) {
  return {
    columns: [
      { Header: "Tipo", accessor: "MachineType", align: "left" },
      { Header: "Máquina", accessor: "Machine", align: "left" },
    ],

    rows: (machines || []).map((m) => ({
      MachineType: m.MachineType?.Type || "Sin tipo",
      Machine: `${m.SerialNumber || "Sin serie"} · ${m.Name || "Sin nombre"}`,
    })),
  };
}
